import React, {useEffect, useState} from 'react';
import Menu from './Components/MainMenu/Menu';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Login from './Pages/Login';
import Registration from './Pages/Registration';
import Athletes from './Pages/Athletes';
import AthletesNew from './Pages/Athletes/New';
import AthletesDetail from './Pages/Athletes/Detail';
import AthletesEdit from './Pages/Athletes/Edit';
import AthletesShooting from './Pages/Athletes/Shooting';
import AthletesGroups from './Pages/Athletes/Groups';
import AthletesGroupNew from  './Pages/Athletes/GroupNew';
import AthletesEquiptment from './Pages/Athletes/Equiptment';
import AthletesEquiptmentNew from './Pages/Athletes/EquiptmentNew';
import Events from './Pages/Events';
import EventsNew from './Pages/Events/New';
import EventEdit from './Pages/Events/Edit';
import EventsDetail from './Pages/Events/Detail';
import EventsAthlete from './Pages/Events/Athlete';
import EventsAthleteEdit from './Pages/Events/AthleteEdit';
import Home from './Pages/Home';
import Settings from './Pages/Settings';
import Shooting from './Pages/Shooting';
import ShootingDetail from './Pages/Shooting/Detail';

import {doAllSync} from "./Sync/syncUtils";


import "./i18n"; // Import the i18n setup

let syncIntervalId = null;
let syncStarted = false;

function App() {
    const [isSynced, setIsSynced] = useState(false);
    const syncInterval = 10000;

    useEffect(() => {
        const initSync = async () => {
            if (!syncStarted) {
                syncStarted = true;
                await doAllSync(true);
                setIsSynced(true);

                if (!syncIntervalId) {
                    syncIntervalId = setInterval(() => {
                        doAllSync();
                    }, syncInterval);
                }
            }
        };
        initSync();

        return () => {
            if (syncIntervalId) {
                clearInterval(syncIntervalId);
                syncIntervalId = null;
            }
        };
    }, []);

    if (!isSynced) {
        return (
            <div className="flex items-center justify-center h-[100dvh]">
                <div className="text-xl font-bold animate-pulse">Synchronizing...</div>
            </div>
        );
    }

    return (
        <Router>
            <div className="flex flex-col h-[100dvh] text-[var(--dark-color)] select-none">
                <div className="grow overflow-y-auto">
                  <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="/login" element={<Login />} />
                      <Route path="/registration" element={<Registration />} />
                      <Route path="/events" element={<Events />} />
                      <Route path="/events/new" element={<EventsNew />} />
                      <Route path="/events/:id" element={<EventsDetail />} />
                      <Route path="/events/:id/edit" element={<EventEdit />} />
                      <Route path="/events/:id/athlete/:athlete" element={<EventsAthlete />} />
                      <Route path="/events/:id/athlete/:athlete/edit" element={<EventsAthleteEdit />} />
                      <Route path="/athletes" element={<Athletes />} />
                      <Route path="/athletes/new" element={<AthletesNew />} />
                      <Route path="/athletes/groups" element={<AthletesGroups />} />
                      <Route path="/athletes/groups/new" element={<AthletesGroupNew />} />
                      <Route path="/athletes/equiptment" element={<AthletesEquiptment />} />
                      <Route path="/athletes/equiptment/new" element={<AthletesEquiptmentNew />} />
                      <Route path="/athletes/:id" element={<AthletesDetail />} />
                      <Route path="/athletes/:id/edit" element={<AthletesEdit />} />
                      <Route path="/athletes/:id/shooting" element={<AthletesShooting />} />
                      <Route path="/settings" element={<Settings />} />
                      <Route path="/shooting" element={<Shooting />} />
                      <Route path="/shooting/:id" element={<ShootingDetail />} />
                  </Routes>
                </div>

                <div className="shrink-0 select-none">
                    <Menu />
                </div>
            </div>
        </Router>
    );
}

export default App;